/**
 * PlanShelf — objectives / sprints / decisions / projects-strip.
 *
 * Phase 6 §"6-shelf reserve (Plan / Design / Execute / Verify / Govern
 * + Broadcast slot)". The vocabulary discipline rule (Round 6 UX #1):
 * verb-as-noun labels at the top level, sub-entities use product names.
 */

import { ShelfCard } from "./ShelfCard";
import type { ShelfLabelResolver } from "./types";
import { IDENTITY_SHELF_LABEL } from "./types";

interface Props {
  projectId?: string | null;
  /** Template-layer vocabulary SKIN resolver, supplied ONCE by ShelfSidebar
   *  (one deduped fetch for all shelves). Defaults to canonical when absent, so
   *  a shelf rendered in isolation stays verbatim. Only entity-type cards skin;
   *  verb/tool cards (Sprints, Decisions, Projects) are left canonical. */
  label?: ShelfLabelResolver;
}

export function PlanShelf({ projectId, label = IDENTITY_SHELF_LABEL }: Props) {
  const base = projectId ? `/projects/${projectId}` : "";
  return (
    <div
      data-testid="plan-shelf"
      role="region"
      aria-label="Plan"
      className="grid grid-cols-1 gap-2 p-3 sm:grid-cols-2"
    >
      <ShelfCard
        to={`${base}/objectives`}
        label={label("objective", { plural: true, fallback: "Objectives" })}
        testId="plan-objectives"
      />
      <ShelfCard
        to={`${base}/sprints`}
        label="Sprints"
        testId="plan-sprints"
      />
      <ShelfCard
        to={`${base}/decisions-needed`}
        label="Decisions"
        testId="plan-decisions"
      />
      <ShelfCard
        to={`/projects`}
        label="Projects"
        testId="plan-projects"
      />
    </div>
  );
}
